import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useCart } from '../../contexts/CartContext';

export default function Header() {
  const { user, signOut } = useAuth();
  const { getCartCount } = useCart();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const cartCount = getCartCount();

  const handleSignOut = async () => {
    try {
      await signOut();
      setShowUserMenu(false);
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100 transition-all">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center gap-12">
              <Link to="/" className="text-2xl font-bold text-gray-900">
                BALIZA<span className="text-orange-600">V16</span>
              </Link>
              <nav className="hidden lg:flex items-center gap-8">
                <Link
                  to="/producto"
                  className="text-sm font-medium text-gray-700 hover:text-orange-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Baliza V16
                </Link>
                <Link
                  to="/producto-directo"
                  className="text-sm font-medium text-gray-700 hover:text-orange-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Normativa DGT
                </Link>
                <a
                  href="/#beneficios"
                  className="text-sm font-medium text-gray-700 hover:text-orange-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Beneficios
                </a>
                <Link
                  to="/contacto"
                  className="text-sm font-medium text-gray-700 hover:text-orange-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Contacto
                </Link>
              </nav>
            </div>
            <div className="flex items-center gap-4">
              <Link
                to="/carrito"
                className="hidden sm:flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 transition-colors cursor-pointer relative"
              >
                <i className="ri-shopping-cart-line text-xl text-gray-700"></i>
                {cartCount > 0 && (
                  <span className="absolute -top-1 -right-1 w-5 h-5 bg-orange-600 text-white text-xs font-bold rounded-full flex items-center justify-center">
                    {cartCount}
                  </span>
                )}
              </Link>

              {user ? (
                <div className="relative">
                  <button
                    onClick={() => setShowUserMenu(!showUserMenu)}
                    className="flex items-center gap-2 px-4 py-2 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <div className="w-8 h-8 bg-orange-600 rounded-full flex items-center justify-center">
                      <i className="ri-user-line text-white"></i>
                    </div>
                    <span className="text-sm font-medium text-gray-700 hidden lg:block">
                      {user.email?.split('@')[0]}
                    </span>
                    <i className="ri-arrow-down-s-line text-gray-600"></i>
                  </button>
                  {showUserMenu && (
                    <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                      <Link
                        to="/perfil"
                        className="block px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-user-line mr-2"></i>
                        Mi Perfil
                      </Link>
                      <Link
                        to="/pedidos"
                        className="block px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-shopping-bag-line mr-2"></i>
                        Mis Pedidos
                      </Link>
                      <button
                        onClick={handleSignOut}
                        className="w-full text-left px-4 py-3 text-red-600 hover:bg-red-50 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-logout-box-line mr-2"></i>
                        Cerrar Sesión
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  to="/producto"
                  className="px-6 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors cursor-pointer whitespace-nowrap font-semibold"
                >
                  Baliza V16
                </Link>
              )}

              <button
                onClick={() => setShowMobileMenu(!showMobileMenu)}
                className="lg:hidden flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <i className={`ri-${showMobileMenu ? 'close' : 'menu'}-line text-xl text-gray-700`}></i>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      {showMobileMenu && (
        <div className="fixed top-20 left-0 right-0 z-40 bg-white border-b border-gray-100 lg:hidden">
          <nav className="container mx-auto px-4 py-4 space-y-2">
            <Link
              to="/producto"
              className="block py-2 text-sm font-medium text-gray-700 hover:text-orange-600 transition-colors cursor-pointer"
              onClick={() => setShowMobileMenu(false)}
            >
              Baliza V16
            </Link>
            <Link
              to="/producto-directo"
              className="block py-2 text-sm font-medium text-gray-700 hover:text-orange-600 transition-colors cursor-pointer"
              onClick={() => setShowMobileMenu(false)}
            >
              Normativa DGT
            </Link>
            <a
              href="/#beneficios"
              className="block py-2 text-sm font-medium text-gray-700 hover:text-orange-600 transition-colors cursor-pointer"
              onClick={() => setShowMobileMenu(false)}
            >
              Beneficios
            </a>
            <Link
              to="/contacto"
              className="block py-2 text-sm font-medium text-gray-700 hover:text-orange-600 transition-colors cursor-pointer"
              onClick={() => setShowMobileMenu(false)}
            >
              Contacto
            </Link>
            <div className="pt-2 border-t border-gray-100">
              <Link
                to="/carrito"
                className="block py-2 text-sm font-medium text-gray-700 hover:text-orange-600 transition-colors cursor-pointer"
                onClick={() => setShowMobileMenu(false)}
              >
                <i className="ri-shopping-cart-line mr-2"></i>
                Carrito {cartCount > 0 && `(${cartCount})`}
              </Link>
              {user ? (
                <>
                  <Link
                    to="/perfil"
                    className="block py-2 text-sm font-medium text-gray-700 hover:text-orange-600 transition-colors cursor-pointer"
                    onClick={() => setShowMobileMenu(false)}
                  >
                    <i className="ri-user-line mr-2"></i>
                    Mi Perfil
                  </Link>
                  <Link
                    to="/pedidos"
                    className="block py-2 text-sm font-medium text-gray-700 hover:text-orange-600 transition-colors cursor-pointer"
                    onClick={() => setShowMobileMenu(false)}
                  >
                    <i className="ri-shopping-bag-line mr-2"></i>
                    Mis Pedidos
                  </Link>
                  <button
                    onClick={() => {
                      handleSignOut();
                      setShowMobileMenu(false);
                    }}
                    className="w-full text-left py-2 text-sm font-medium text-red-600 hover:text-red-700 transition-colors cursor-pointer"
                  >
                    <i className="ri-logout-box-line mr-2"></i>
                    Cerrar Sesión
                  </button>
                </>
              ) : (
                <Link
                  to="/login"
                  className="block py-2 text-sm font-medium text-orange-600 hover:text-orange-700 transition-colors cursor-pointer"
                  onClick={() => setShowMobileMenu(false)}
                >
                  <i className="ri-login-box-line mr-2"></i>
                  Iniciar Sesión
                </Link>
              )}
            </div>
          </nav>
        </div>
      )}
    </>
  );
}
